import { Skeleton } from '@/components/ui/skeleton'
import { useTranslations } from "next-intl"


export function WidgetContactSettingsSkeleton() {
  const tUi = useTranslations("Messaging.AgentsMessagingSettingsWidgetContactSettingsSkeleton")

  return (
    <div role="status" aria-label={tUi("loadingContactChannels")} aria-busy="true" className="h-[520px] min-w-0 overflow-hidden">
      <span className="sr-only"><span key={tUi("loadingContactChannels2")}>{tUi("loadingContactChannels2")}</span></span>
      <div aria-hidden="true" className="grid h-full min-w-0 gap-6 lg:grid-cols-[minmax(0,1fr)_340px]">
        <div className="min-w-0 space-y-4">
          <div className="flex items-center gap-3 rounded-xl border p-5">
            <Skeleton className="h-6 w-11 shrink-0 motion-reduce:animate-none" />
            <div className="min-w-0 flex-1 space-y-2">
              <Skeleton className="h-4 w-3/4 motion-reduce:animate-none" />
              <Skeleton className="h-3 w-full motion-reduce:animate-none" />
            </div>
          </div>
          <div className="space-y-5 rounded-xl border p-5">
            <Skeleton className="h-5 w-40 motion-reduce:animate-none" />
            {[0, 1].map(row => (
              <div key={row} className="space-y-3">
                <div className="flex items-center gap-3">
                  <Skeleton className="h-11 w-11 shrink-0 rounded-full motion-reduce:animate-none" />
                  <div className="min-w-0 flex-1 space-y-2">
                    <Skeleton className="h-4 w-1/2 motion-reduce:animate-none" />
                    <Skeleton className="h-3 w-3/4 motion-reduce:animate-none" />
                  </div>
                </div>
                <Skeleton className="h-9 w-full motion-reduce:animate-none" />
              </div>
            ))}
          </div>
          <div className="space-y-4 rounded-xl border p-5">
            <Skeleton className="h-5 w-28 motion-reduce:animate-none" />
            <Skeleton className="h-9 w-full motion-reduce:animate-none" />
          </div>
          <Skeleton className="h-10 w-32 motion-reduce:animate-none" />
        </div>
        <div className="hidden h-full space-y-3 lg:block">
          <Skeleton className="h-4 w-56 motion-reduce:animate-none" />
          <div className="flex h-[464px] flex-col overflow-hidden rounded-2xl border">
            <Skeleton className="h-20 w-full shrink-0 rounded-none motion-reduce:animate-none" />
            <div className="flex justify-center gap-4 border-b p-4">
              {[0, 1, 2, 3].map(icon => <Skeleton key={icon} className="h-11 w-11 rounded-full motion-reduce:animate-none" />)}
            </div>
            <div className="flex-1 space-y-3 p-4">
              <Skeleton className="h-14 w-4/5 motion-reduce:animate-none" />
              <Skeleton className="ml-auto h-9 w-1/2 motion-reduce:animate-none" />
            </div>
            <div className="border-t p-3"><Skeleton className="h-10 w-full motion-reduce:animate-none" /></div>
          </div>
        </div>
      </div>
    </div>
  )
}
